// AR (MSA)
export const propCreateHc = {
  firstCreate: {
    // أنواع أماكن الإقامة
    typeApartmentLabel: `شقة`,
    typeApartmentDesc: `مكان إقامة مفروش ومستقل يُؤجَّر بالكامل.`,
    typeVillaLabel: `فيلا أو منزل`,
    typeVillaDesc: `منازل وفيلات وشاليهات تُؤجَّر بالكامل.`,
    typeHotelLabel: `فندق أو نُزُل أو مبيت وإفطار`,
    typeHotelDesc: `أماكن إقامة تدير عدة غرف.`,
    typeCampingLabel: `تخييم`,
    typeCampingDesc: `مخيمات وقطع بها عدة أماكن أو وحدات.`,

    // مصطلحات المنشأة / الوحدة
    venueHotel: `فندق`,
    venueCamping: `مخيم`,
    roomHotel: `غرفة`,
    roomCamping: `قطعة`,
    roomHotelPlural: `غرف`,
    roomCampingPlural: `قطع`,
    yourVenue: `{venue}ك`,

    // أزرار عامة
    back: `رجوع`,
    continue: `متابعة`,

    // الخطوة: النوع
    typeTitle: `لنُسجّل مكان إقامتك!`,
    typeSubtitle: `للبدء، اختر نوع مكان الإقامة الذي تريد نشره.`,

    // الخطوة: الكمية
    quantityTitle: `كم عدد أماكن الإقامة التي تريد تسجيلها؟`,
    quantitySubtitle: `يمكنك البدء بواحد أو إنشاء عدة أماكن دفعة واحدة.`,
    oneTitle: `مكان إقامة واحد`,
    oneDesc: `أريد نشر واحد فقط في الوقت الحالي.`,
    manyTitle: `أكثر من مكان إقامة واحد`,
    manyDesc: `لدي عدة أماكن لتسجيلها.`,

    // الخطوة: الموقع (نفس المبنى أم لا)
    locationTitle: `هل هي في نفس المبنى أو العنوان؟`,
    locationSubtitle: `يساعدنا هذا على تنظيم أماكن إقامتك بأفضل طريقة.`,
    sameBuildingYesTitle: `نعم، في نفس المبنى أو العنوان`,
    sameBuildingYesDesc: `ستُجمَّع في إعلان واحد يضم عدة وحدات.`,
    sameBuildingNoTitle: `لا، في عناوين مختلفة`,
    sameBuildingNoDesc: `سيكون كل منها إعلانًا مستقلًا (تُعِدّه لاحقًا).`,

    // الخطوة: الأسماء (عناوين وعناوين فرعية ديناميكية)
    namesTitleAttach: `أضف وحدة إلى إعلانك`,
    namesTitleHotel: `ما اسم {venue}ك؟`,
    namesTitleGrouped: `سمِّ كل وحدة`,
    namesTitleList: `سمِّ كل مكان إقامة`,
    namesTitleDefault: `ما اسم مكان إقامتك؟`,
    namesSubAttach: `ستُضاف كوحدة جديدة داخل «{name}».`,
    yourListing: `إعلانك`,
    namesSubHotel: `هذا هو الاسم الذي سيراه ضيوفك. في الخطوة التالية تضيف أنواع {room}.`,
    namesSubGrouped: `سيكون لكل وحدة تقويمها الخاص ضمن الإعلان نفسه.`,
    namesSubList: `سيكون كل منها إعلانًا مستقلًا بإعداداته الخاصة.`,
    namesSubDefault: `هذا هو الاسم الذي سيراه ضيوفك. يمكنك تغييره متى شئت.`,
    addUnitLabel: `إضافة وحدة أخرى`,
    addListingLabel: `إضافة مكان إقامة آخر`,

    // بطاقة الإعلان الرئيسي (مجمّع)
    mainListingEyebrow: `الإعلان الرئيسي`,
    mainListingSub: `يجمع كل وحدات هذا المبنى في إعلان واحد.`,
    mainListingNameLabel: `اسم مكان الإقامة الرئيسي`,
    mainListingNamePlaceholder: `مثال: Residencial Bilbao`,
    mainListingNameHint: `المبنى أو البرج أو الموقع الذي يجمع الوحدات.`,
    currency: `العملة`,
    currencyHintUnit: `السعر لليلة لكل وحدة.`,

    // بطاقات الوحدة
    unitNameLabel: `اسم الوحدة`,
    listingNameLabel: `اسم مكان الإقامة`,
    phRoomCamping: `مثال: Camping Pinar del Mar`,
    phRoomHotel: `مثال: Hotel Costa Azul`,
    phAttach: `مثال: استوديو فاخر في Playa Roca، على الواجهة البحرية`,
    phGrouped: `مثال: شقة {n}A`,
    phList: `مكان إقامة {n}`,
    phDefault: `مثال: شقة وسط المدينة`,
    remove: `إزالة`,
    internalNameOptional: `الاسم الداخلي (اختياري)`,
    pricePerNight: `السعر / لليلة`,
    currencyHintHotel: `تستخدم كل {rooms} هذه العملة.`,

    // الاسم الداخلي (حالة الاسم الواحد)
    internalNameLabel: `الاسم الداخلي`,
    optional: `(اختياري)`,
    internalNamePlaceholderSingle: `مثال: شقة مُجدَّدة 2024 / مفاتيح الاستقبال`,
    internalNameHint: `تراه أنت فقط، لتمييزه داخليًا. لا يظهر للضيوف.`,

    // الخطوة: أنواع الغرف (فندق/تخييم)
    roomsTitle: `ما {rooms} التي يضمها {venue}؟`,
    roomsSubtitle: `أضف كل نوع من {room} مع كميته وسعره لليلة. يمكنك تعديله متى شئت.`,
    roomTypeLabel: `نوع {room}`,
    phRoomTypeCamping: `مثال: قطعة بها كهرباء`,
    phRoomTypeHotel: `مثال: غرفة مزدوجة ديلوكس`,
    quantity: `الكمية`,
    addRoomType: `إضافة نوع {room}`,

    // الخطوة: العنوان
    addressTitle: `أين يقع مكان إقامتك؟`,
    addressSubtitle: `ابدأ بالكتابة واختر العنوان. نستخدمه للخريطة وتسجيل الوصول.`,
    country: `الدولة`,
    countryHint: `سنبحث عن العناوين داخل هذه الدولة فقط.`,
    address: `العنوان`,
    addressPlaceholder: `الشارع، الرقم، المدينة…`,
    addressPlaceholderNoCountry: `اختر الدولة أولًا`,
    city: `المدينة`,
    zipCode: `الرمز البريدي`,

    // الخطوة: السعر
    priceTitle: `سعرك القياسي لليلة`,
    priceSubtitle: `هذا سعرك الأساسي. يمكنك بعد ذلك تعديله حسب الموسم أو القناة.`,
    priceLabel: `السعر لليلة`,
    perNight: `/ لليلة`,
    priceHint: `يمكنك تغييره متى شئت من لوحة التحكم.`,

    // الزر الرئيسي وسبب الإنشاء
    createUnit: `إضافة وحدة`,
    createVenue: `إنشاء {venue}ي`,
    createListingsPlural: `إنشاء مكان إقامتي | إنشاء {count} أماكن إقامتي`,
    reasonUnit: `وحدة`,
    reasonListing: `إعلان`,

    // إشعارات / تحقق
    toastCompleteToContinue: `أكمل البيانات للمتابعة.`,
    toastCompleteNames: `أكمل اسم كل مكان إقامة.`,
    toastCompleteLocation: `أكمل الموقع.`,
    toastCompleteRooms: `أكمل كل غرفة: الاسم والكمية والسعر لليلة.`,
    toastRoomRatePerUnit: `أدخل السعر لليلة لكل وحدة.`,
    toastCompleteRate: `أكمل السعر لليلة.`,
    toastCreatedPlural: `تم إنشاء مكان الإقامة! | تم إنشاء أماكن الإقامة!`,
    toastCreateError: `تعذّر علينا إنشاء مكان الإقامة. حاول مرة أخرى.`,
  },

  welcome: {
    // عناوين الرأس
    arrivalTitleCaps: `تعليمات الوصول`,
    arrivalTitle: `تعليمات الوصول`,
    arrivalSubtitle: `الرسالة التي يتلقاها الضيف يوم وصوله.`,
    welcomeTitle: `رسالة الترحيب`,
    welcomeSubtitle: `الرسالة التي يتلقاها الضيف بعد إتمام تسجيله.`,
    loadingMessages: `جارٍ تحميل الرسائل...`,

    // ترحيب على مستوى الغرفة
    roomWelcomeTitle: `رسالة الترحيب الخاصة بهذه الغرفة`,
    roomWelcomeSub: `إذا تركتها فارغة، تُرسَل رسالة الترحيب العامة للفندق. يُضبَط المفتاح والمرفقات وقنوات OTA على مستوى الفندق.`,

    // مفتاح الترحيب
    welcomeEnableTitle: `إرسال رسالة الترحيب`,
    welcomeEnableSub: `يتلقاها الضيف بعد إتمام تسجيله. إذا أوقفتها، فلن تُرسَل.`,

    // الاستنساخ
    clone: `استنساخ`,
    clonePullTitle: `جلب الإعدادات من مكان إقامة آخر`,
    clonePullSub: `استورد الترحيب من مكان آخر إلى هذا`,
    clonePushTitle: `نسخ هذا الإعداد إلى مكان إقامة آخر`,
    clonePushSub: `طبّق هذا الترحيب على أماكن أخرى`,
    cloneModalPullTitle: `جلب إعدادات الترحيب`,
    cloneModalPushTitle: `نسخ رسالة الترحيب`,
    cloneModalPullSubtitle: `اختر مكان الإقامة الذي تريد جلب الإعدادات منه. ستُطبَّق على هذا الإعلان.`,
    cloneModalPushSubtitle: `انسخ هذا الإعداد (النصوص والوضع وقنوات OTA والمرفقات) إلى أماكن الإقامة التي تختارها.`,
    itemNounWelcome: `رسالة الترحيب`,
    arrivalTitleNoun: `تعليمات الوصول`,
    itemNounArrival: `تعليمات الوصول`,

    // وضع الإعداد
    modeConfigLabel: `وضع الإعداد`,
    modeSingleTitle: `رسالة واحدة`,
    modeSingleDesc: `تشترك كل الوحدات في الرسالة نفسها`,
    modeActive: `نشط`,
    modePropertyTitle: `لكل عقار`,
    modePropertyDesc: `لكل وحدة رسالتها الخاصة`,
    modePropertyNotice: `الوضع الفردي نشط. عدّل الرسالة من كل عقار.`,

    // مفتاح الوصول
    arrivalEnableTitle: `إرسال تعليمات الوصول`,
    arrivalAutoSend: `تُرسَل تلقائيًا يوم الوصول{atTime}.`,
    arrivalAtTime: ` الساعة {time}`,

    // القنوات / الإرسال
    deliveryChannels: `قنوات الإرسال`,
    channelEmail: `البريد الإلكتروني`,
    sendAlsoOta: `الإرسال أيضًا عبر OTA`,
    sendTime: `وقت الإرسال`,

    // المحرر
    editorSubtitle: `اضبطها حسب اللغة. نصيحة: استخدم الرموز التعبيرية ونصًا قصيرًا.`,
    translateTitle: `الترجمة من {lang} إلى بقية اللغات`,
    translatingLangLabel: `جارٍ ترجمة {lang}…`,
    translatingGeneric: `جارٍ الترجمة…`,
    translate: `ترجمة`,

    // المرفقات
    uploading: `جارٍ الرفع…`,
    attach: `إرفاق`,
    emojis: `رموز تعبيرية`,
    variables: `المتغيرات`,
    variablesHint: `انقر لإدراجها. تُستبدَل ببيانات الحجز الحقيقية عند الإرسال.`,
    uploadDone: `تم الإرسال. جارٍ حفظه على الخادم…`,
    uploadSizeProgress: `{done} من {total} ميجابايت`,
    attachHint: `الصور وملفات PDF حتى {fileMb} ميجابايت · مقاطع فيديو MP4 حتى {videoMb} ميجابايت.`,
    whatsappLimits: `هذه هي الحدود التي يسمح بها WhatsApp.`,
    openFile: `فتح {name}`,
    attachmentFallback: `مرفق`,
    delete: `حذف`,
    open: `فتح`,
    arrivalAttachments: `مرفقات تعليمات الوصول`,
    welcomeAttachments: `مرفقات رسالة الترحيب`,
    attachHintFull: `الصور وملفات PDF حتى {fileMb} ميجابايت · مقاطع فيديو MP4 حتى {videoMb} ميجابايت. هذه هي الحدود التي يسمح بها WhatsApp.`,
    noAttachments: `لا توجد مرفقات بعد.`,
    editorSubtitleProperty: `اضبطها حسب اللغة وأرفق الملفات (صور، PDF، فيديو).`,

    // الحفظ
    saveData: `حفظ البيانات`,
    saving: `جارٍ الحفظ…`,

    // ملخص الأقفال
    locksConfigured: `الأقفال المُعدَّة`,
    accessMethodConfigured: `طريقة الوصول المُعدَّة`,
    guestAccess: `وصول الضيف`,
    accessDisabledHtml: `إرسال رموز الوصول <strong>مُعطَّل</strong>، ولن يُدرَج في تعليمات الوصول.`,
    noAccessMethod: `لا توجد بعد أي طريقة وصول مُعدَّة لمكان الإقامة هذا.`,
    locksHint: `يُضبَط في بطاقة «الأقفال والوصول» الخاصة بالإعلان.`,

    // المعاينة
    online: `متصل`,
    previewDayArrival: `يوم الوصول`,
    previewAfterRegister: `بعد التسجيل`,
    previewPlaceholder: `اكتب الرسالة لترى المعاينة هنا…`,
    previewIncludesAccess: `يتضمن الوصول المُعدّ`,
    languageLabel: `لغة {lang}`,
    previewFallbackName: `مكان إقامتك`,
    previewFallbackAccommodation: `مكان إقامتك`,

    // ملخصات القفل (computed)
    lockNoteDynamic: `يُنشأ مفتاح جديد تلقائيًا لكل حجز`,
    lockTagBox: `رمز صندوق المفاتيح`,
    lockTag: `الرمز`,
    lockCodePending: `الرمز قيد الإعداد`,
    lockCodeValue: `{tag}: {code}`,
    lockLabelDefault: `المدخل`,

    // رسائل معاينة الوصول (computed)
    lockMsgDynamic: `🔒🔑 *{label} · {name}*\n\nرمز وصولك هو: *58117*\n\nصالح طوال إقامتك.`,
    lockMsgBox: `🔑 *{label} · {name}*\n\nيُفتَح صندوق المفاتيح بالرمز: *{code}*\n\nستجد بداخله مفاتيح مكان الإقامة. من فضلك أعِدها عند المغادرة.`,
    lockMsgStatic: `🔒🔑 *{label} · {name}*\n\nرمز القفل هو: *{code}*\n\nاستخدمه لفتح باب مكان الإقامة.`,

    // تسميات المتغيرات (computed)
    varGuestName: `اسم الضيف`,
    varFullName: `الاسم الكامل`,
    varCheckinDate: `تاريخ الوصول`,
    varCheckoutDate: `تاريخ المغادرة`,
    varCheckinTime: `وقت تسجيل الوصول`,
    varCheckoutTime: `وقت تسجيل المغادرة`,
    varNights: `عدد الليالي`,
    varGuests: `عدد الضيوف`,

    // خيارات القفل (computed)
    lockOptBoxTitle: `صندوق المفاتيح`,
    lockOptBoxDesc: `توجد المفاتيح في صندوق مفاتيح آمن.`,
    lockOptDynamicTitle: `قفل ذكي`,
    lockOptDynamicDesc: `يُنشئ كل حجز مفتاحًا جديدًا تلقائيًا.`,
    lockOptStaticTitle: `قفل برمز ثابت`,
    lockOptStaticDesc: `صندوق مفاتيح أو قفل برمز ثابت.`,

    // رسالة الوصول الافتراضية (computed)
    defaultArrivalMessage: `🏡 *تعليمات الوصول*\n\nمرحبًا *{guest}* 👋\n\nعند وصولك، توجّه إلى المدخل الرئيسي لمكان الإقامة. 🔑\n\nإذا احتجت إلى مساعدة، راسِلنا عبر WhatsApp نفسه 📲\n\nإقامة سعيدة! ✨`,

    // سياق العقار (موروث)
    inheritedChannelsTitle: `قنوات موروثة من الإعلان`,
    inheritedListingPrefix: `يستخدم هذا العقار الترحيب المركزي للإعلان`,
    emailChannel: `البريد الإلكتروني`,
    otaActive: `OTA نشطة`,
    inheritedNote: `إذا أردت تغيير الإرسال عبر OTA لهذا الترحيب، فافعل ذلك من إعدادات الإعلان.`,
    propertyDeliveryTitle: `كيف سيُرسَل هذا الترحيب؟`,
    propertyDeliverySubtitle: `اضبط قنوات الإرسال لهذا العقار.`,
    propertyDeliveryNote: `تظل هذه القنوات نشطة افتراضيًا. يمكنك هنا أيضًا إضافة الإرسال عبر OTA لهذا العقار.`,
    otaRowTitle: `إرسال رسائل الترحيب عبر قنوات OTA`,
    otaRowText: `سيحاول إرسال ترحيب هذا العقار عبر Booking.com وAirbnb باستخدام Channex، مع مرفقاته المُعدَّة.`,
    otaRowHint: `يُحفَظ مع رسالة الترحيب ومرفقاتها.`,

    // إشعارات / تحقق
    toastLoadError: `تعذّر تحميل الرسائل.`,
    toastOtaUpdated: `تم تحديث قناة OTA بنجاح`,
    toastOtaError: `تعذّر تحديث الإرسال عبر OTA`,
    toastSendTimeUpdated: `تم تحديث وقت الإرسال`,
    toastSendTimeError: `تعذّر حفظ الوقت`,
    toastArrivalEnabled: `تم تفعيل تعليمات الوصول`,
    toastArrivalDisabled: `تم إيقاف تعليمات الوصول`,
    toastStatusError: `تعذّر تحديث الحالة`,
    toastWelcomeEnabled: `تم تفعيل رسالة الترحيب`,
    toastWelcomeDisabled: `تم إيقاف رسالة الترحيب`,
    toastModeUpdated: `تم تحديث الوضع بنجاح`,
    toastModeError: `تعذّر تحديث الوضع`,
    toastAttachUploaded: `تم رفع المرفق (المرفقات) بنجاح`,
    toastAttachUploadError: `خطأ في رفع المرفقات`,
    toastAttachDeleted: `تم حذف المرفق`,
    toastAttachDeleteError: `تعذّر حذف المرفق`,
    toastChangesSaved: `تم حفظ التغييرات`,
    toastTranslateEmpty: `اكتب رسالة باللغة النشطة قبل الترجمة.`,
    toastTranslateSuccess: `تمت ترجمة {count} لغات! راجع كل تبويب قبل الحفظ.`,
    toastTranslatePartial: `تمت ترجمة {success}، وفشلت {failed}. يمكنك المحاولة مرة أخرى.`,
    toastTranslateNone: `تعذّر ترجمة أي لغة. حاول مرة أخرى.`,

    // أخطاء التحقق من الملفات (WhatsApp)
    fileErrorVideoFormat: `❌ {name} فيديو بصيغة {ext} وWhatsApp يدعم MP4 فقط. حوّله إلى MP4 وأعِد رفعه.`,
    fileErrorTooBig: `❌ حجم {name} هو {mb} ميجابايت والحد الأقصى هو {limMb} ميجابايت. `,
    fileErrorTooBigVideo: `لا يسمح WhatsApp بمقاطع فيديو أكبر: اضغطه أو اقتطعه.`,
    fileErrorTooBigFile: `لا يسمح WhatsApp بملفات أكبر.`,
  },
};
